import React from 'react'
import ListOfStates from './ListOfStates'

export default function Statewise() {
    return (
        <div>
            <ListOfStates/>
        </div>
    )
}
